import React, { useState } from 'react';
import * as AppPics from 'assets/images';
import { Link } from 'react-router-dom';
import { AppRadioBox } from 'components';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { ArrowsPng } from 'assets/images';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';
import useDeleteSupportCategory from 'hooks/API/DELETE/useDeleteSupportCategory';
import { QueryClient } from 'react-query';
import { notifier } from 'components/Toaster';
import { useHistory, useLocation } from 'react-router-dom';
import useGetSupportTopic from 'hooks/API/GET/useGetSupportTopic';
import { useParams } from 'react-router-dom';

const actionsConfig = {
  open: false,
  data: {},
  Header: null,
  Body: null,
  isDeleteOperation: false,
};

function SupportTopics() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const redirectBack = queryParams.get('redirect_back');
  const { categoryId } = useParams();

  const { data } = useGetSupportTopic({
    categoryId,
    enabled: true,
  });
  const { mutate: deleteCategory } = useDeleteSupportCategory();
  const categoryData = data?.data?.data?.result;

  const [actions, setActions] = useState({ ...actionsConfig });
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleDelete = (category) => {
    setSelectedCategory(category);
    setActions({
      open: true,
      data: { id: category.id },
      Header: 'Delete Category',
      Body: `Are you sure you want to delete "${category?.title}"?`,
      isDeleteOperation: true,
    });
  };

  const handleDeleteConfirm = () => {
    deleteCategory(actions.data.id, {
      onSuccess: (res) => {
        notifier.success(res?.data?.data?.message);
        QueryClient.invalidateQueries('support-category');
      },
      onError: (err) => {
        notifier.error(err?.response?.data?.data?.message);
      },
    });
    setActions({ ...actionsConfig });
  };

  const handleBackNavigation = () => {
    if (redirectBack) {
      // Use the redirect_back URL if available
      history.push(decodeURIComponent(redirectBack));
    } else {
      // Fallback to podcast list route
      history.push('/support/category');
    }
  };

  return (
    <>
      {/* Delete Modal Placeholder */}
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions({ ...actionsConfig })}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={handleDeleteConfirm}
      />

      <div className="mainWraper coursetabsection">
        <div className="tab">
          <ul className="tab__menu">
            <li className="back">
              <button className="btn-back" onClick={handleBackNavigation}>
                <img src={AppPics.BackSvg} alt="Back" />
              </button>
            </li>
          </ul>

          <div className="tab__content ___adjust___tab___padding">
            <div className="tab__content-actHead">
              <AppBreadcrumbs
                links={[
                  { label: 'Dashboard', to: '/dashboard' },
                  { label: 'Support Category', to: '/support/category' },
                ]}
                current="Topics"
              />
            </div>

            <div className="tab__content-actBody">
              <div className="px-5 py-5">
                <div className="tab__contentMenu">
                  <ul className="tab__contentMenu-list">
                    <li>
                      <h2 className="prime-head p-0 boldtitle text-nowrap">
                        Manage Support Topics
                      </h2>
                    </li>
                  </ul>

                  <div className="mainHeader__search">
                    <ul className="tab__contentMenu-list">
                      <li className="relative">
                        <input
                          className="mainHeader__searchInput"
                          placeholder="Search Category..."
                          type="text"
                        />
                        <span className="mainHeader__searchBtn">
                          <img src={AppPics.TopMenuSearchSvg} alt="Search" />
                        </span>
                      </li>

                      {/* <li className="px-4 flex items-center">
                        <button type="button" className="flex items-center gap-1">
                          <img src={AppPics.TabFilterSvg} alt="Filter" />
                          <span className="viewsettingtitle">Filter</span>
                        </button>
                      </li> */}
                    </ul>
                  </div>

                  <div className="flex items-center gap-10">
                    {/* <Link to="/podcast/category/reorder">
                      <img
                        src={ArrowsPng}
                        alt="Reorder Genre"
                        title="Reorder Genre"
                        className="cursor-pointer"
                      />
                    </Link> */}

                    <Link to={`/support/category/${categoryId}/topics/add`}>
                      <button className="btn-left-content add">New Topic</button>
                    </Link>
                  </div>
                </div>

                {/* Filter Section */}
                {/* <div className="row mt-3">
                  <div className="col-lg-3 d-flex">
                    <button
                      type="button"
                      className="btn btn-plane p--tint"
                      style={{ alignSelf: 'end' }}
                    >
                      Clear filter
                    </button>
                  </div>
                </div> */}

                {/* Table */}
                <div className="tab__contentBody">
                  <div className="tableWrap">
                    <div className="table-responsive">
                      <table className="table tableWrap__table">
                        <thead className="thead-light __appTheadColor">
                          <tr>
                            <th className="text-center">#</th>
                            <th className="text-center">Topic Name</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {categoryData && categoryData?.length > 0 ? (
                            categoryData?.map((item, index) => (
                              <tr key={item?.id}>
                                <td className="text-center">{index + 1}</td>
                                <td className="text-center">{item?.title}</td>
                                <td className="text-center">
                                  <Link
                                    className="actions-icons mx-2 text-primary"
                                    title="Edit"
                                    to={`/support/category/${item?.id}`}
                                  >
                                    <img src={AppPics.EditSvg} alt="Edit" />
                                  </Link>

                                  <button
                                    className="actions-icons mx-2 text-danger"
                                    title="Delete"
                                    onClick={() => handleDelete(item)}
                                  >
                                    <img src={AppPics.DeleteSvg} alt="Delete" />
                                  </button>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={4} className="text-center py-4">
                                No Data
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* Pagination Placeholder */}
                  {/* <TablePaginate /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupportTopics;
